import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_CONTENT = {
  hero_image:
    "https://images.unsplash.com/photo-1573167627769-e201a7ddf409?crop=entropy&cs=srgb&fm=jpg&q=85",
  hero_title_line1: "BELIEVE",
  hero_title_line2: "TEAM.",
  hero_eyebrow: "Insurance, Reimagined.",
  hero_tagline:
    "An independent insurance firm protecting families, founders, and Fortune 500s — with the quiet precision of a craftsman and the conviction of a believer.",
  hero_photo_caption_label: "The Team — Est. 2003",
  hero_photo_caption_title: "Twenty-one years. One unwavering belief.",
  mission_eyebrow: "Our Mission",
  mission_headline:
    "Insurance built on a single, stubborn belief — that people deserve to be protected, not processed.",
  mission_body: "",
  stats: [],
  milestones: [],
  services: [],
  press: [],
  contact_phone: "+1 (212) 555 0143",
  contact_address: "432 Park Ave, NY",
};

const ContentContext = createContext({
  content: FALLBACK_CONTENT,
  team: [],
  loading: true,
  refresh: () => {},
});

// Resolve relative upload URLs against backend host
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(FALLBACK_CONTENT);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent({ ...FALLBACK_CONTENT, ...data.content });
      setTeam(data.team || []);
    } catch (e) {
      console.error("Failed to load content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, team, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
